import cx from 'classnames';

import {AnimatedText, Button} from '#component/base';
import {ShareTrigger, Transition} from '#component/util';
import {useOnceEffect, useViewportSize} from '#hook';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';
import {animTextCentered, animTextHighlight} from '../StorySteps.css';

import * as css from './Step5.css';

export const Step5 = ({afterEnter, percentiles, formattedDeltaAge, isYounger, show}: StepProps) => {
  const {isDesktop} = useViewportSize();

  useOnceEffect(() => {
    // Since the transitions on this step are so short, enforce a minimum duration.
    setTimeout(() => {
      afterEnter?.();
    }, 1500);
  });

  return (
    <Transition className={sprinkles({position: 'absolute', inset: 0})} show={show}>
      <div className={cx(animTextCentered, sprinkles({gap: 64}))}>
        <p>
          <AnimatedText as="span" color="white" variant="heading3">
            Share your journey to living healthier, longer using
          </AnimatedText>

          <AnimatedText as="span" className={animTextHighlight} delay={100} variant="heading3">
            #welcometoanewage
          </AnimatedText>

          <AnimatedText as="span" color="white" delay={120} variant="heading3">
            to inspire your friends.
          </AnimatedText>
        </p>

        {isDesktop && (
          <Transition.Child className={css.shareButton}>
            <ShareTrigger
              formattedDeltaAge={formattedDeltaAge}
              isYounger={isYounger}
              percentile={
                percentiles && percentiles.length > 0 && percentiles[0].percentile
                  ? percentiles[0].percentile
                  : undefined
              }>
              {({onClick}) => (
                <Button icon="ShareNetwork" onClick={onClick} variant="primary-dark">
                  Share your results
                </Button>
              )}
            </ShareTrigger>
          </Transition.Child>
        )}
      </div>
    </Transition>
  );
};
